module.exports = __webpack_public_path__ + "img/Tajikistan.2e61311d.gif";